import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import IconButton from '@mui/joy/IconButton';
import { useContext,useState,useEffect } from 'react';
import { ContextFromSelections,FetchedDataContext } from './Context';
import { Sheet } from '@mui/joy';
import {Box} from '@mui/joy';
import {Typography} from '@mui/material';
import FormControl from '@mui/joy/FormControl';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';






function SheetForFontColor({bg_color}) {
    return(
        <Sheet
        variant='outlined'
        sx={{
          p: 1,
          borderRadius: 'sm',
          width: 30,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: bg_color,
        }}>
        </Sheet>
    );
}

function OptionModified({color_bg,value}) {
    return(
        <Option
        value={value}
        sx={{
          fontSize: 13,
          fontWeight: '500',
          alignItems: 'center',
        }}>
            
            <SheetForFontColor bg_color={color_bg}/>
            {value}
        </Option>
    
    );
}


export default function SelectFontColor() {

  
  
  const [selectedData, setSelectedData] = useContext(ContextFromSelections);
  const [value, setValue] = useState(selectedData.fontColor);
  const FetchedData = useContext(FetchedDataContext)
  const [RibbonFontColors,setRibbonFontColor] = useState([])
  

  useEffect(() => {
    setRibbonFontColor(FetchedData.get("fetchedFontColors")
  )
  },[FetchedData])

  return (
    

  <FormControl>
  <Typography fontSize={12} >Print Color</Typography>
    <Select
      size='sm'
      value={value}
      placeholder="Select print Color"
      onChange={(event, newValue) => {
        setValue(newValue)
        RibbonFontColors.map((fontcolor) => {
          if(fontcolor.color_name === newValue) {
            setSelectedData((data) => ({...data, fontColorCode: fontcolor.color_code}))
          }
          })
        setSelectedData((data) =>({...data, fontColor: newValue}))
      }}
        

      {...(value && {
        
        startDecorator: (<SheetForFontColor bg_color={selectedData.fontColorCode}/>),
        endDecorator: (
          <IconButton
            variant="plain"
            color="neutral"
            onMouseDown={(event) => {
              event.stopPropagation();
            }}
            onClick={() => {
              setValue(null);
              setSelectedData((data) =>({...data, fontColor: null, fontColorCode: null}))
            }}
          >
            <CloseTwoToneIcon />
          </IconButton>
        ),
        indicator: null,
      })}
      sx={{
        width:{ xs: 160, sm: 170},
        height: 30,
        fontSize: 13,
        fontStyle: '500',
        
      }}
    >
        {RibbonFontColors &&
         RibbonFontColors.map((fontcolor,index) => (
           <Box  key={index} sx={{width:{ xs: 160, sm: 170}}}>
            <OptionModified
              key={index}
              color_bg={fontcolor.color_code}
              value={fontcolor.color_name}
             />
             </Box>
        )
    )
    
    }
    </Select>
    </FormControl>
  

  );
}
